module.exports = __webpack_public_path__ + "img/49_1.48b3c216.png";